/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const BtnPrimary = ({
  withIcon = false,
  text = "Button",
  off = false,
  className,
  divClassName,
  center = false,
}) => {
  return (
    <button className={`btn-primary off-${off} ${className}`}>
      {!center ? (
        <div className={`text-wrapper ${divClassName}`}>{text}</div>
      ) : (
        <div className={`${divClassName}`} style={{ textAlign: "center" }}>
          {text}
        </div>
      )}
    </button>
  );
};

BtnPrimary.propTypes = {
  withIcon: PropTypes.bool,
  text: PropTypes.string,
  off: PropTypes.bool,
};
